/* eslint-disable no-func-assign */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

import * as _high_contrast_media_query from '../utils/high_contrast_media_query';

import * as _typography from '../utils/typography';

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

var styles = function styles(_ref) {
  var icon = _ref.icon,
    isActive = _ref.isActive,
    isMobile = _ref.isMobile,
    theme = _ref.theme;
  return {
    segment: _extends(
      {
        alignItems: 'center',
        border: '1px solid '.concat(theme.palette?.primary.default),
        color: theme.palette?.primary.default,
        cursor: 'pointer',
        display: 'flex'
      },
      (0, _typography.default)(theme).label,
      {
        transition: 'color 150ms ease',
        padding: icon
          ? theme.orbitalThree
          : 'calc('
              .concat(theme.orbitalFour, ' - 3px) ')
              .concat(theme.orbitalSix),
        position: 'relative'
      },
      !isActive && {
        '&:hover': {
          backgroundColor: theme.palette?.primary.backgroundLight,
          color: theme.palette?.primary.hover,
          transition: 'background 0.1s ease'
        },
        '&:active': {
          backgroundColor: theme.palette?.primary.background,
          color: theme.palette?.primary.active,
          transition: 'background 0.1s ease'
        }
      },
      !isMobile && {
        '&:first-of-type': {
          borderTopLeftRadius: theme.borderRadius3,
          borderBottomLeftRadius: theme.borderRadius3,
          borderRight: 'none'
        },
        '&:last-of-type': {
          borderTopRightRadius: theme.borderRadius3,
          borderBottomRightRadius: theme.borderRadius3,
          borderLeft: 'none'
        },
        '&:not(:first-of-type):not(:last-of-type)': {
          borderRight: 'none',
          borderLeft: 'none'
        }
      },
      (0, _high_contrast_media_query.default)()
    ),
    active: {
      color: theme.palette?.primary.foreground,
      cursor: 'default',
      fill: 'currentColor'
    },
    label: {
      cursor: !isActive && 'pointer',
      fontFamily: theme.fontTextRegular,
      padding: '4px 14px'
    },
    icon: {
      color: 'inherit',
      fill: 'currentColor'
    },
    mobile: {
      '&:first-of-type': {
        borderBottom: 'none',
        borderTopLeftRadius: theme.borderRadius4,
        borderTopRightRadius: theme.borderRadius4
      },
      '&:last-of-type': {
        borderBottomLeftRadius: theme.borderRadius4,
        borderBottomRightRadius: theme.borderRadius4,
        borderTop: 'none'
      },
      '&:not(:first-of-type):not(:last-of-type)': {
        borderBottom: 'none',
        borderTop: 'none'
      }
    }
  };
};

var _default = styles;
export default _default;
